// import { mapGetters } from 'vuex'

// computed: {
//   ...mapGetters([
//     // 员工
//     'aaa',
//   ])
// }

// 赋值：this.$store.commit('SET_AAA', 'aaa')
const temp = {
  state: {
    headerIndex: 0,
    pageReloadState: false,
		
		winScroll: '',  // 滚动高度
		
		searchStr: '',
		searchFuncState: false,
		
		articleRightId: '',  // article-Right-Id
  },

  mutations: {
		SET_WINSCROLL: (state, val) => {
      state.winScroll = val
    },
		
    SET_HEADERINDEX: (state, val) => {
      state.headerIndex = val
    },
    SET_PAGERELOAD_STATE: (state, val) => {
      state.pageReloadState = val
    },
		SET_SEARCHSTR: (state, val) => {
		  state.searchStr = val
		},
		SET_SEARCHFUNC_STATE: (state, val) => {
		  state.searchFuncState = val
		},
		SET_ARTICLE_RIGHT_ID: (state, val) => {
			console.log('val', val);
		  state.articleRightId = val
		},
  },
  actions: {
    
  }
}

export default temp



// WEBPACK FOOTER //
// ./src/store/modules/header.js